import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { VideocamIcon } from '../../icons';

type Props = {
	onRecord: () => void;
	onSkip: () => void;
};

/**
 * The ask's action group: the video CTA, the permission note that explains what tapping it does,
 * and the low-emphasis skip.
 *
 * Separate from the ask itself only so neither reads as a wall of markup; the entrance animation and
 * the group's own spacing stay with the ask, which owns the cascade down the screen.
 */
export const AskActions: React.FC<Props> = ({ onRecord, onSkip }) => (
	<>
		<Button
			data-testid="create-video"
			data-qa="create-video"
			variant="primary"
			size="large"
			className="w-full"
			leadingIcon={<VideocamIcon />}
			onClick={onRecord}
		>
			<Translate value="corgi.petition_actions.video_first_ask.cta" />
		</Button>
		<Text as="p" variant="body" size="x-small" className="text-typography-weak mt-2 w-[266px] max-w-full text-center">
			<Translate value="corgi.petition_actions.video_first_ask.permission_note" />
		</Text>
		{/* Set apart from the button and its note above, rather than reading as a third item in one
		    evenly-spaced stack. */}
		<div className="mt-5">
			<Button data-testid="create-comment" data-qa="create-comment" variant="tertiary" size="small" onClick={onSkip}>
				<Translate value="corgi.petition_actions.skip" />
			</Button>
		</div>
	</>
);
